/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  FormValidation,
  FormValidationLength,
  FormValidationRegex,
  FormValidationRequired,
  FormValidationText,
  FormValidationValue,
} from '../typings';

type ValidationValue = number | string | undefined;
export type ValidationType = FormValidation;

const createValidation = (type: ValidationType, value?: ValidationValue) => ({
  type,
  ...(value !== undefined && { value }),
});

const formatDateString = (date: string): string => {
  const [month, day, year] = date.split('/');
  return `${year}/${month}/${day}`;
};

export const createFormFieldValidation = {
  [FormValidation.Required]: () =>
    createValidation(FormValidation.Required) as FormValidationRequired,
  [FormValidation.Email]: () =>
    createValidation(FormValidation.Email) as FormValidationText,
  [FormValidation.Url]: () =>
    createValidation(FormValidation.Url) as FormValidationText,
  [FormValidation.MinValue]: (value: number | string) => {
    if (typeof value === 'string') {
      return createValidation(
        FormValidation.MinValue,
        formatDateString(value),
      ) as FormValidationValue;
    }
    return createValidation(
      FormValidation.MinValue,
      value,
    ) as FormValidationValue;
  },
  [FormValidation.MaxValue]: (value: number | string) => {
    if (typeof value === 'string') {
      return createValidation(
        FormValidation.MaxValue,
        formatDateString(value),
      ) as FormValidationValue;
    }
    return createValidation(
      FormValidation.MaxValue,
      value,
    ) as FormValidationValue;
  },
  [FormValidation.MinLength]: (value: number) =>
    createValidation(FormValidation.MinLength, value) as FormValidationLength,
  [FormValidation.MaxLength]: (value: number) =>
    createValidation(FormValidation.MaxLength, value) as FormValidationLength,
  [FormValidation.Regex]: (value: string) =>
    createValidation(FormValidation.Regex, value) as FormValidationRegex,
} as const;
